export const TAB_VALUE = {
  LESSON: 'LESSON',
  QUESTION: 'QUESTION',
}
